"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_UPDATE_SCENE_LAYERS = exports.BROADCAST_SET_SCENE_LAYERS = void 0;
var BROADCAST_UPDATE_SCENE_LAYERS = exports.BROADCAST_UPDATE_SCENE_LAYERS = 'BROADCAST_UPDATE_SCENE_LAYERS';
var BROADCAST_SET_SCENE_LAYERS = exports.BROADCAST_SET_SCENE_LAYERS = 'BROADCAST_SET_SCENE_LAYERS';